'use client';

import Portal from '@wconcept/wconcept-ui-renewal/src/components/atoms/Portal';
import ToastPopup from '@wconcept/wconcept-ui-renewal/components/molecules/ToastPopup';
import { useToastPopupStore } from '@wconcept/wconcept-display/store/toast';
import useGlobalState from '@hooks/useGlobalState';
import { getToastBottom, TOAST_BOTTOM_DEFAULT } from '@utils/getToastBottom';
import { useEffect, useState } from 'react';

const TOAST_VISIBLE_DURATION_MS = 2000;
const TOAST_FADE_DURATION_MS = 300;

export default function GlobalToastPopup() {
  const { toastMessage, resetToastMessage, toastKey } = useToastPopupStore();
  const { appInfo } = useGlobalState();
  const [toastPop, setToastPop] = useState(false);
  const [displayText, setDisplayText] = useState('');
  const [bottom, setBottom] = useState(TOAST_BOTTOM_DEFAULT);

  useEffect(() => {
    if (!toastMessage) return undefined;

    setBottom(getToastBottom(!!appInfo?.isNativeAppBoth));

    // 텍스트 세팅 + active ON (페이드 인)
    setDisplayText(toastMessage);
    setToastPop(true);

    // 일정 시간 후 active OFF → CSS 트랜지션이 페이드 아웃 실행
    const hideTimer = window.setTimeout(() => {
      setToastPop(false);
    }, TOAST_VISIBLE_DURATION_MS);

    // 페이드 아웃 끝난 후 store 정리 + DOM 정리
    const resetTimer = window.setTimeout(() => {
      resetToastMessage();
      setDisplayText('');
    }, TOAST_VISIBLE_DURATION_MS + TOAST_FADE_DURATION_MS);

    return () => {
      window.clearTimeout(hideTimer);
      window.clearTimeout(resetTimer);
    };
  }, [toastMessage, toastKey, resetToastMessage, appInfo?.isNativeAppBoth]);

  if (!displayText) return null;

  return (
    <Portal>
      <ToastPopup
        key={toastKey}
        bottom={bottom}
        text={
          <span
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: displayText }}
          />
        }
      />
    </Portal>
  );
}
